/* 未来如果还有类似checkbox的情况，
  需要往里面添加变成checkbox的值
*/
export const checkboxList = [
    {
      "valueEn": "#2 Right Back",
      "value": "#2 右边后卫",
      "key": "2-right-back"
    },
    {
      "valueEn": "#3 Right Centre Back",
      "value": "#3 右中卫",
      "key": "3-right-centre-back"
    },
    {
      "valueEn": "#4 Left Centre Back",
      "value": "#4 左中卫",
      "key": "4-left-centre-back"
    },
    {
      "valueEn": "#5 Left Back",
      "value": "#5 左边后卫",
      "key": "5-left-back"
    },
    {
      "valueEn": "#6 Defensive Midfielder",
      "value": "#6 后腰",
      "key": "6-defensive-midfielder"
    },
    {
      "valueEn": "#7 Right Winger",
      "value": "#7 右边锋",
      "key": "7-right-winger"
    },
    {
      "valueEn": "#8 Left Midfielder",
      "value": "#8 左中场",
      "key": "8-left-midfielder"
    },
    {
      "valueEn": "#9 Striker",
      "value": "#9 中锋",
      "key": "9-striker"
    },
    {
      "valueEn": "#10 Right Midfielder",
      "value": "#10 右中场",
      "key": "10-right-midfielder"
    },
    {
      "valueEn": "#11 Left Winger",
      "value": "#11 左边锋",
      "key": "11-left-winger"
    }
]

export const checkboxValues = checkboxList.map(item => item.key)

